<template>
  <span
    v-if="hasNavTile(color)"
    class="tw:w-6 tw:h-6 tw:rounded-md tw:flex tw:items-center tw:justify-center tw:shrink-0 tw:text-white"
    :style="{ backgroundColor: resolveNavColor(color) }"
    aria-hidden="true"
  >
    <component :is="resolveNavIcon(icon)" class="tw:w-4 tw:h-4" :stroke-width="2.25" />
  </span>
  <!-- No tile: the icon fills the same 24px slot, in the row's own text color. -->
  <span
    v-else
    class="tw:w-6 tw:h-6 tw:flex tw:items-center tw:justify-center tw:shrink-0"
    aria-hidden="true"
  >
    <component :is="resolveNavIcon(icon)" class="tw:w-5 tw:h-5" />
  </span>
</template>

<script setup lang="ts">
import { resolveNavIcon } from './navIcons'
import { hasNavTile, resolveNavColor } from './navColors'

defineProps<{
  icon: string | undefined
  color: string | undefined
}>()
</script>
